import {mapState} from 'vuex';
import values from 'lodash/values';
import {objectToListOptions} from "~/helpers/common";

export default {
  computed: {
    ...mapState({
      settings: rootState => rootState.settings
    }),
    handlePensionInsurance() {
      const result = objectToListOptions(this.settings.company_info.pension_insurance, true, 'id', 'value');

      return values(result);
    },
    handleEmploymentInsurance() {
      const result = objectToListOptions(this.settings.company_info.employment_insurance, true, 'id', 'value');

      return values(result);
    }
  },
  methods: {
    getHealthInsurance(value) {
      const healthInsurance = this.settings.company_info.health_insurance;

      return healthInsurance[value];
    },
    getPensionInsurance(value) {
      const pensionInsurance = this.settings.company_info.pension_insurance;

      return pensionInsurance[value];
    },
    getLongtermCareInsurance(value) {
      const longtermCareInsurance = this.settings.company_info.longterm_care_insurance;

      return longtermCareInsurance[value];
    },
    getEmploymentInsurance(value) {
      const employmentInsurance = this.settings.company_info.employment_insurance;

      return employmentInsurance[value];
    },
    getLaborAccidentInsurance(value) {
      const laborAccidentInsurance = this.settings.company_info.labor_accident_insurance;

      return laborAccidentInsurance[value];
    }
  }
}